import React, { useState, useEffect, useRef, useMemo, useCallback } from "react";
import { Route, Routes, Link, Navigate, useLocation } from "react-router-dom";
import Dashboard from "./Dashboard";
import EmployeeDashboard from "../pages/EmployeeDashboard/EmployeeDashboard";
import TaxSlabListPage from "../pages/TaxSlab/TaxSlabList";
import PayrollListPage from "../pages/PayRolles/PayrollListPage";
import LeaveListPage from "../pages/Leaves/LeaveRequestListPage";
import LeaveBalanceApp from "../pages/Leave_Balance/LeaveBalanceApp";
import AttendanceApp from "../pages/Attendance/AttendanceApp";

import LoginPage from "../pages/LoginPage";
import Designations from "../pages/Designation/DesignationList";
import Departments from "../pages/Department/DepartmentList";
import PayslipsPage from "../pages/PaySlips/PayslipsPage";
import HolidayPage from "../pages/Holiday/HolidayCalender";
import HolidayMasterPage from "../pages/Holiday/HolidayMasterList";
import ProjectList from "../pages/Project/ProjectList";
import TaskList from "../pages/Task/TaskList";
import ChallanMasterList from "../pages/Challans/ChallanList";
import { useDispatch, useSelector } from "react-redux";
import "../styles/layout.css";
import "../styles/styles.css";
import "../pages/Profile/Profile.css";
import { Logout } from "@mui/icons-material";
import {
  ArrowDropDown,
  ArrowDropUp,
  KeyboardArrowDown,
  KeyboardArrowUp,
  Dashboard as DashboardIcon,
  People as PeopleIcon,
  EventNote as EventNoteIcon,
  Menu as MenuIcon,
  Business as BusinessIcon,
  Work as WorkIcon,
  Payments as PaymentsIcon,
  ReceiptLong as ReceiptIcon,
  Schedule as ScheduleIcon,
  Assessment as AssessmentIcon,
  TaskAlt as TaskIcon,
} from "@mui/icons-material";
import axios from "axios";
import AuthViewController from "../redux/actions/AuthViewController";
import CompanyVeiwController from "../redux/actions/companyApiActions";
import { image_url } from "../redux/actions/AuthViewController";
import MasterViewController from "../redux/actions/masterApiActions";
import CompanyList from "../pages/Companies/CompanyList";
import EmployersList from "../pages/Employers/EmployersList";
import UserListPage from "../pages/Employees/UserListPage";
import RoleListPage from "../pages/Roles/RoleListPage";
import ModuleMasterListPage from "../pages/ModuleMaster/ModuleMasterListPage";
import AnnouncementList from "../pages/Announcement/AnnouncementList";
import ShiftMasterList from "../pages/Shifts/ShiftMasterList";
import AssignShiftList from "../pages/Shifts/AssignShiftList";
import ActivationSuccessPage from "../pages/AccountActivationPage";
import ResetPasswordPage from "../pages/ResetPasswordPage";
import EmployeeProfileVeiwController from "../redux/actions/EmployeeProfileApiAction";
import MainDashboard from "../pages/Dasboard/MainDashboard";
import AdminHolidayMasterList from "../pages/Holiday/AdminHolidayMasterList";
import EmployerHolidayMasterList from "../pages/Holiday/EmployerHolidayMasterList";
import EmployeeSelfOnboardingForm from "../pages/EmployeeOnboarding/EmployeeSelfOnboardingForm";
import ForgotPassword from "../pages/ForgotPassword/ForgotPasswordPage";
import OtpResetPassword from "../pages/ForgotPassword/OtpResetPassword";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import { IconButton, Menu, MenuItem, useMediaQuery } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import DropDown from "../pages/Profile/ProfileDropDown";
import AccountSettings from "./AccountSettings";
import HeaderNotifications from "./HeaderNotifications";
import ReportListPage from "../pages/Reports/Reports";
import ScrollToTop from "./ScrollToTop";
import AppraisalCycleList from "../pages/Appraisal/AppraisalList";
import AppraisalReviewList from "../pages/AppraisalReview/AppraisalReviewList";
import { IMAGE_URL } from "../services/api";
import ProtectedImage from "./ProtectedImage";
import logo from "../assets/Thryiv_logo_tm_TB.png";
import { getUserInfoFromToken } from "../utils/authUtils";
import TremsAndConditionPage from "../pages/Contract/ContractTermAndConditionList";
import ContractList from "../pages/Contract/ContractList";
import EmpTaxSlab from "../pages/EmployeeTaxSlab/AddEmployeeTaxSlab";
import EmpTaxSlabList from "../pages/EmployeeTaxSlab/EmployeeTaxSlabList";
import HomePage from "../pages/HomePage/HomePage";
import CompanySettings from "../pages/Settings/CompanySettings";
import DocumentList from "../pages/Documents/DocumentList";
import PlansList from "../pages/SubscripationPlans/SubscripationPlansList";
import sidebarMenu from "../config/sidebarMenu";
import { getMobileBottomNavItems } from "../config/mobileBottomNav";
import {
  getVisibleMenuItems,
  splitMenuBySection,
  getBreadcrumbsFromMenu,
} from "../utils/menuUtils";

function DefaultLayout() {
  const dispatch = useDispatch();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const { logout, getUserDetails, getUserPermissions } = AuthViewController();
  const { getAnnouncement } = CompanyVeiwController();
  const { userDetails, permissions, loading } = useSelector((state) => state.auth);
  const [userType, setUserType] = useState(null);
  const [userId, setUserId] = useState(null);
  const token = localStorage.getItem('access_token');
  
  // const userType = localStorage.getItem("user_type");
  // const userId = localStorage.getItem("user_id");
  const companyName = userDetails?.company?.company_name || "Company";
  const userDisplayName = [userDetails?.first_name, userDetails?.last_name]
    .filter(Boolean)
    .join(" ");
  const userMetaLabel =
    userDetails?.employee_id ||
    (userType === "Admin" ? "Admin" : userType) ||
    "";

  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [openSubMenuId, setOpenSubMenuId] = useState(null);

  const location = useLocation();
  const isAuthenticated = !!localStorage.getItem("access_token");
  const [showDropdown, setShowDropdown] = useState(false);
  const dropdownRef = useRef();

  const visibleMenu = useMemo(
    () => getVisibleMenuItems(sidebarMenu, userType, permissions),
    [userType, permissions]
  );
  const { main: mainMenuItems, settings: settingsMenuItems } = useMemo(
    () => splitMenuBySection(visibleMenu),
    [visibleMenu]
  );

  const showNotifications = visibleMenu.some(
    (item) =>
      item.path === "/announcement" ||
      item.id === "announcements"
  );

  const handleLogout = () => {
    setOpenSubMenuId(null);
    setIsDrawerOpen(false);
    dispatch(logout());
  };

  const toggleDrawer = () => {
    setIsDrawerOpen(!isDrawerOpen);
  };

  const closeDrawer = useCallback(() => {
    setIsDrawerOpen(false);
  }, []);

  useEffect(() => {
    closeDrawer();
  }, [location.pathname, closeDrawer]);

  useEffect(() => {
    if (!isMobile || !isDrawerOpen) return undefined;

    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = previousOverflow;
    };
  }, [isDrawerOpen, isMobile]);

  const handleSubMenuToggle = (menuId) => {
    setOpenSubMenuId(openSubMenuId === menuId ? null : menuId);
  };

  const formikRef = useRef();
  useEffect(() => {
    const { userType, userId } = getUserInfoFromToken();
    setUserType(userType);
    setUserId(userId);
  }, [location.pathname]);

  useEffect(() => {
    const token = localStorage.getItem("access_token");
    if (token) {
      dispatch(getUserDetails());
      dispatch(getUserPermissions());
    }
  }, [location.pathname]);

  useEffect(() => {
    const token = localStorage.getItem("access_token");
    if (showNotifications && token) {
      dispatch(getAnnouncement());
    }
  }, [location.pathname, showNotifications]);

  useEffect(() => {
    const activeParent = visibleMenu.find(
      (item) =>
        item.children &&
        item.children.some((child) => location.pathname === child.path)
    );
    if (activeParent) {
      setOpenSubMenuId(activeParent.id);
    }
  }, [location.pathname, visibleMenu]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowDropdown(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const breadcrumbs = getBreadcrumbsFromMenu(sidebarMenu, location.pathname);

  const bottomNavIconMap = {
    dashboard: DashboardIcon,
    business: BusinessIcon,
    work: WorkIcon,
    people: PeopleIcon,
    payments: PaymentsIcon,
    receipt: ReceiptIcon,
    schedule: ScheduleIcon,
    event: EventNoteIcon,
    assessment: AssessmentIcon,
    task: TaskIcon,
  };

  const mobileBottomNavItems = useMemo(
    () => getMobileBottomNavItems(userType, permissions),
    [userType, permissions]
  );

  const renderMenuItems = useCallback(
    (items) =>
      items.map((route) => {
        const isOpen = openSubMenuId === route.id;
        const isActive =
          location.pathname === route.path ||
          route.children?.some((child) => location.pathname === child.path);

        if (route.children?.length) {
          return (
            <li key={route.id}>
              <div className={`side-nav-group ${isOpen ? "is-open" : ""}`}>
                <Link
                  to={route.path}
                  className={`side-nav-link side-nav-parent ${
                    isActive ? "active" : ""
                  } ${isOpen ? "expanded" : ""}`}
                  onClick={(e) => {
                    e.preventDefault();
                    handleSubMenuToggle(route.id);
                  }}
                >
                  <span className="side-nav-label">{route.name}</span>
                  {isOpen ? (
                    <KeyboardArrowUp className="custom-icon" />
                  ) : (
                    <KeyboardArrowDown className="custom-icon" />
                  )}
                </Link>
                {isOpen && (
                  <ul className="sub-menu">
                    {route.children.map((child) => (
                      <li key={child.id}>
                        <Link
                          to={child.path}
                          className={`side-nav-link side-nav-child ${
                            location.pathname === child.path ? "active" : ""
                          }`}
                          onClick={() => {
                            if (window.innerWidth < 768) closeDrawer();
                          }}
                        >
                          {child.name}
                        </Link>
                      </li>
                    ))}
                  </ul>
                )}
              </div>
            </li>
          );
        }

        return (
          <li key={route.id}>
            <Link
              to={route.path}
              className={`side-nav-link ${
                location.pathname === route.path ? "active" : ""
              }`}
              onClick={() => {
                setOpenSubMenuId(null);
                if (window.innerWidth < 768) closeDrawer();
              }}
            >
              <span className="side-nav-label">{route.name}</span>
            </Link>
          </li>
        );
      }),
    [location.pathname, openSubMenuId]
  );
  const isLoginPage = location.pathname === "/login";
  const isActivationPage = location.pathname.startsWith("/activate/");
  const isResetPasswordPage = location.pathname.startsWith("/reset-password");
  const isOnboardingPage = location.pathname.startsWith("/onboarding-form/");

  if (!isAuthenticated || isActivationPage || isResetPasswordPage || isOnboardingPage) {
    return (
      <div
        className={`app-container${isOnboardingPage ? " app-container--onboarding" : ""}`}
        style={
          isOnboardingPage
            ? undefined
            : {
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }
        }
      >
        <Routes>
          <Route
            path="/onboarding-form/:uid/:token"
            element={<EmployeeSelfOnboardingForm />}
          />
          <Route path="/home" element={<HomePage />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/otp-reset" element={<OtpResetPassword />} />
          <Route
            path="/activate/:uid/:token"
            element={<ActivationSuccessPage />}
          />
          <Route
            path="/reset-password/:uid/:token"
            element={<ResetPasswordPage />}
          />
          <Route path="*" element={<Navigate to="/login" replace />} />
          <Route path="/" element={<Navigate to="/login" replace />} />
        </Routes>
      </div>
    );
  }

  return (
    <div className="app-container">
      <header className="app-header">
        <div className="app-header-left">
          <button
            type="button"
            className={`app-header-menu-btn menu-button${isDrawerOpen ? " is-open" : ""}`}
            onClick={toggleDrawer}
            aria-label={isDrawerOpen ? "Close menu" : "Open menu"}
            aria-expanded={isDrawerOpen}
          >
            <MenuIcon />
          </button>
          <div className="app-header-brand">
            {userType === "Admin" ? (
              <>
                <img src={logo} alt="Thryiv" className="app-logo" />
                <span className="app-role-badge">Admin</span>
              </>
            ) : userDetails?.company?.company_logo ? (
              <ProtectedImage
                path={userDetails.company.company_logo}
                alt={`${companyName} Logo`}
                className="company-logo"
              />
            ) : (
              <h4 className="app-title">{companyName}</h4>
            )}
          </div>
          <div id="header-title-portal" style={{ display: 'flex', alignItems: 'center' }} />
        </div>

        <div id="header-actions-portal" style={{ display: 'flex', alignItems: 'center', flex: 1, justifyContent: 'flex-end', marginRight: '16px' }} />
        <div className="app-header-actions">
          {showNotifications && <HeaderNotifications />}
          <AccountSettings userDetails={userDetails} onLogout={handleLogout} />

          {/* {userDetails?.first_name && userDetails?.last_name && (
            <div
              className="user-initials-circle"
              title={`${userDetails.first_name} ${userDetails.last_name}`}
              onClick={(e) => {
                e.stopPropagation(); // Prevent bubbling issues
                setShowDropdown((prev) => !prev);
              }}
            >
              {`${userDetails.first_name[0]}${userDetails.last_name[0]}`.toUpperCase()}
            </div>
          )}

          {showDropdown && (
            <div ref={dropdownRef}>
              <DropDown userDetails={userDetails} onLogout={handleLogout} />
            </div>
          )} */}
        </div>
      </header>

      {isMobile && isDrawerOpen && (
        <button
          type="button"
          className="side-nav-overlay"
          aria-label="Close menu"
          onClick={closeDrawer}
        />
      )}

      <nav className={`side-nav ${isDrawerOpen ? "open" : ""}`}>
        <div className="side-nav-header">
          <div className="side-nav-header-top">
            <div className="side-nav-header-logo-wrap">
              {userType === "Admin" ? (
                <img src={logo} alt="Thryiv" className="side-nav-header-logo" />
              ) : userDetails?.company?.company_logo ? (
                <ProtectedImage
                  path={userDetails.company.company_logo}
                  alt={`${companyName} Logo`}
                  className="side-nav-header-logo"
                />
              ) : (
                <div className="side-nav-header-logo-fallback">
                  {companyName?.charAt(0)?.toUpperCase() || "C"}
                </div>
              )}
            </div>
            <div className="side-nav-header-info">
              <span className="side-nav-header-company">{companyName}</span>
              {userDisplayName && (
                <p className="side-nav-header-name">{userDisplayName}</p>
              )}
              {userMetaLabel && (
                <p className="side-nav-header-meta">{userMetaLabel}</p>
              )}
            </div>
          </div>
        </div>
        <div className="side-nav-inner">
          <ul>{renderMenuItems(mainMenuItems)}</ul>
        </div>
        {settingsMenuItems.length > 0 && (
          <div className="side-nav-settings">
            <ul>{renderMenuItems(settingsMenuItems)}</ul>
          </div>
        )}
        <div className="side-nav-footer">
          <button type="button" className="side-nav-logout" onClick={handleLogout}>
            <Logout />
            <span>Logout</span>
          </button>
        </div>
      </nav>
      <ScrollToTop />
      <main className="app-main">

        <div className="app-main-content">
          <Routes>
            <Route path="/" element={<MainDashboard />} />
            <Route path="/login" element={<MainDashboard />} />
            <Route path="/company" element={<CompanyList />} />
            <Route path="/employer" element={<EmployersList />} />
            <Route path="/users" element={<UserListPage />} />
            <Route path="/roles" element={<RoleListPage />} />
            <Route path="/module-master" element={<ModuleMasterListPage />} />
            <Route path="/departments" element={<Departments />} />
            <Route path="/designations" element={<Designations />} />
             <Route path="/plans" element={<PlansList />} />
            <Route
              path="/holiday-master"
              element={<AdminHolidayMasterList />}
            />
            <Route
              path="/organization-holiday"
              element={<EmployerHolidayMasterList />}
            />
            <Route path="/challan-master" element={<ChallanMasterList />} />
            <Route path="/tax-slab" element={<TaxSlabListPage />} />
            <Route path="/payrolls" element={<PayrollListPage />} />
            <Route path="/pay-slips" element={<PayslipsPage />} />
            <Route path="/employee_Payslips" element={<PayslipsPage />} />
            <Route path="/reports" element={<ReportListPage />} />
            <Route path="/appraisal" element={<AppraisalCycleList />} />
            <Route path="/review" element={<AppraisalReviewList />} />
            <Route path="/leaves" element={<LeaveListPage />} />
            <Route path="/leave-balance" element={<LeaveBalanceApp />} />
            <Route path="/employeet-tax-slab" element={<EmpTaxSlabList />} />
            <Route path="/holidays" element={<HolidayPage />} />
            <Route path="/documents" element={<DocumentList />} />
            <Route path="/terms" element={<TremsAndConditionPage />} />
            <Route path="/contract" element={<ContractList />} />
            <Route path="/time-attendance" element={<AttendanceApp />} />
            <Route path="/employee_attendance" element={<AttendanceApp />} />

            <Route path="/projects" element={<ProjectList />} />
            <Route path="/tasks" element={<TaskList />} />
            <Route path="/employee_task_issue" element={<TaskList />} />
            <Route path="/announcement" element={<AnnouncementList />} />
            <Route path="/shifts" element={<ShiftMasterList />} />
            <Route path="/assign-shift" element={<AssignShiftList />} />
            <Route path="/company-settings" element={<CompanySettings />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </div>
      </main>

      {/* Mobile Bottom Navigation */}
      <div
        className="bottom-nav"
        data-count={mobileBottomNavItems.length}
      >
        {mobileBottomNavItems.map((item) => {
          const Icon = bottomNavIconMap[item.iconKey] || DashboardIcon;
          const isActive = item.isActive(location.pathname);

          return (
            <Link
              key={item.path}
              to={item.path}
              className={`bottom-nav-item${isActive ? " active" : ""}`}
            >
              <Icon />
              <span>{item.label}</span>
            </Link>
          );
        })}
      </div>
    </div>
  );
}

export default DefaultLayout;
